import { useState } from 'react'
import { ApiError } from '../api/client'
import { know } from '../api/know'
import { useAuth } from '../auth/AuthContext'
import { CONSENT_ACCEPT_LABEL, ConsentNotice } from '../components/ConsentNotice'
import { useTabletContext } from './TabletLayout'

/**
 * Firma del consentimiento informado en la tablet, cuando el login devolvió
 * `gates.consent_required`. Mismo texto y mismo endpoint que el gate de la
 * HomePage (`know.recordMyConsent`); acá se presenta como checklist —
 * marcar que se leyó y recién ahí habilitar el botón — porque en un
 * dispositivo compartido el jugador llega apurado y con el compañero atrás,
 * y un botón único invita a tocarlo sin leer.
 *
 * Va ANTES del cuestionario: sin consentimiento no se recolecta nada.
 */
export function TabletConsentScreen() {
  const { onConsentDone, endSession } = useTabletContext()
  const { refresh } = useAuth()
  const [checked, setChecked] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function accept() {
    setBusy(true)
    setError(null)
    try {
      await know.recordMyConsent()
      // Mismo patrón que la HomePage: refrescamos /auth/me para que
      // `consent_ok` quede al día en toda la app.
      await refresh()
      onConsentDone()
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'No se pudo registrar el consentimiento.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="panel max-w-2xl p-2xl">
      <h1 className="text-2xl">Consentimiento</h1>
      <p className="mt-sm text-base text-text-secondary">
        Antes de entrenar necesitamos tu consentimiento para participar.
      </p>

      <div className="card mt-lg border-primary/30">
        <ConsentNotice />
      </div>

      {error && <div className="banner-err mt-lg">{error}</div>}

      <label className="mt-lg flex cursor-pointer items-start gap-md text-base text-text-secondary">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          className="checkbox mt-0.5"
        />
        <span>Leí y entiendo la información de arriba.</span>
      </label>

      <button
        type="button"
        className="btn-primary mt-lg w-full py-lg text-lg disabled:opacity-50"
        disabled={!checked || busy}
        onClick={() => void accept()}
      >
        {busy ? 'Guardando…' : CONSENT_ACCEPT_LABEL}
      </button>
      <button type="button" className="btn mt-md w-full" disabled={busy} onClick={endSession}>Salir</button>
    </div>
  )
}
